// Import the necessary components
import VerofreshRecord from './VerofreshRecord'
import { indexOf } from 'lodash'
import TemperatureConverterUtil from '@/util/TemperatureConverterUtil.js'

class RouteProductRecord extends VerofreshRecord {
  /**
   * Returns the most recent simulated temperature in the scale defined. If no
   * scale is specified then it defaults to whatever the API responded with. If
   * no temperature has been simulated (as would be the case with a no-data
   * violation) then undefined is returned.
   *
   * @param string scale ensure the temperature returned is in a given scale
   * either 'F' or 'C'
   * @return number|undefined
   */
  getCurrentSimulatedTemperature (scale) {
    if (typeof this.verofresh_temperature !== 'number') {
      return undefined
    }

    const currentScale = this.temperature_scale.toLowerCase()
    const desiredScale = scale.toLowerCase()

    if (currentScale !== desiredScale) {
      return TemperatureConverterUtil.to(this.verofresh_temperature, currentScale, desiredScale)
    }

    return this.verofresh_temperature
  }

  /**
   * Get an array of all violations that match the specified types and levels.
   *
   * @param String|Array types
   * @return Array
   */
  getViolations (types = ['*'], levels = ['*']) {
    if (this.deleted !== undefined && this.deleted !== null) {
      return []
    }

    if (this.violations === undefined || this.violations.length === 0) {
      return []
    }

    if (typeof types === 'string') {
      types = [types]
    }

    if (typeof levels === 'string') {
      levels = [levels]
    }

    // Remove violations that don't match the type(s) specified
    const filteredViolations = indexOf(levels, '*') > -1 ? this.violations
      : this.violations.filter(violation => {
        return indexOf(levels, violation.level) > -1
      })

    // If we have any matching violations and our type is or includes the
    // wildcard '*' then we have a matching violation
    if (indexOf(types, '*') > -1) {
      return filteredViolations
    }

    return filteredViolations.filter(function (violation) {
      return indexOf(types, violation.type) > -1
    })
  }

  getFormattedStartTemp () {
    return TemperatureConverterUtil.formatTemperature(this.start_temp)
  }

  temperatureIcon () {
    switch (this.temperature_scale) {
      case 'F':
        return 'mdi-temperature-fahrenheit'
      default:
        return 'mdi-temperature-celsius'
    }
  }

  /**
   * Returns true/false flag if the record has been soft deleted
   *
   * @return Boolean
   */
  isSoftDeleted () {
    return this.deleted !== undefined && this.deleted !== null
  }
}

const relations = {
  belongsTo: {
    Route: {
      foreignKey: 'route_id',
      localField: 'route'
    },
    Product: {
      foreignKey: 'product_id',
      localField: 'product'
    }
  },
  hasMany: {
    RouteViolation: {
      foreignKey: 'route_product_id',
      localField: 'violations'
    }
  }
}

export default RouteProductRecord
export { relations }
